import React from "react";
import type { TagProps } from "antd";
import { StyledTag } from "./index.styled";

// Already spread onto the antd Tag below; the type just never said so.
type AppTagStatusProps = TagProps & {
  children: React.ReactNode;
};

const AppTagStatus: React.FC<AppTagStatusProps> = ({
  children,
  color,
  className,
  ...rest
}: AppTagStatusProps) => (
  <StyledTag color={color} className={className} {...rest}>
    {children}
  </StyledTag>
);
export default AppTagStatus;
